// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/common/styles/xdaCalendar.less
// module id = 1205
// module chunks = 0